import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import FixedBody from '../../../../Common/FixedBody';
import Permission from '../../../../../classes/common/permission';
import { SingleSlider } from '../../../../Sliders/index';
import { CommentFlatButton, FavoriteFlatButton, ClaimFlatButton } from '../../../../Controls/index';
import { MapsLinkButton } from '../../../../Maps/index';
import { joinWithSeparator, truncText } from '../../../../../utils/formater';
import { getUrlWithSize } from '../../../../../utils/urls';

// TODO: isElit - не известно куда писать (элитное жилье)

class Description extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showFullInfoModal: false
    };

    this.item = this.props.item;
    this.handlerOpenDescriptionModal = this.handlerOpenDescriptionModal.bind(this);
    this.handlerCloseDescriptionModal = this.handlerCloseDescriptionModal.bind(this);
  }

  componentWillReceiveProps (nextProps, nextContext) {
    this.item = nextProps.item;
  }

  handlerOpenDescriptionModal () {
    const isAdmin = this.props.user.getIn(['data', 'isAdmin'], false) || false;

    this.setState({
      showFullInfoModal: isAdmin
    });
  }

  handlerCloseDescriptionModal () {
    this.setState({
      showFullInfoModal: false
    });
  }

  renderLocation () {
    const geoLocation = this.item.getProperty().getGeoLocation();
    const locality = geoLocation.getLocality();
    const region = geoLocation.getRegion();
    const regionDistrict = geoLocation.getRegionDistrict();
    const localityDistrict = geoLocation.getLocalityDistrict();
    const localityMicrodistrict = geoLocation.getLocalityMicrodistrict();
    const isMultiLocality = this.props.domain.get('isMultiLocality');

    return (
      <div className='full-location'>
        {
          [
            (isMultiLocality && locality && locality.name),
            (geoLocation.isSuburb() && region && region.fullName),
            (geoLocation.isSuburb()
                    ? (regionDistrict && regionDistrict.fullName)
                    : joinWithSeparator([
                      localityDistrict && localityDistrict.fullName,
                      localityMicrodistrict && localityMicrodistrict.fullName
                    ])
            )
          ].filter(Boolean).join(', ')
        }
      </div>
    );
  }

  renderControls () {
    const item = this.item;
    const permission = item.getPermissions();
    const author = item.getAuthor();
    const comment = item.getComment();
    const exist = (comment && comment.get('id')) || false;
    const {eventAddFavorites, eventRemoveFavorites, eventOpenCommentForm, eventOpenClaimForm} = this.props;

    return (
      <div className='controls'>
        <FavoriteFlatButton
          userId={this.props.user.getIn(['data', 'id'], null) || null}
          itemId={item.getProperty().getId()}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          active={item.isFavorite()}
          eventAddFavorites={eventAddFavorites}
          eventRemoveFavorites={eventRemoveFavorites}
        />

        <CommentFlatButton
          className={exist ? 'active' : 'hover-visible'}
          comment={comment}
          userId={this.props.user.getIn(['data', 'id'], null) || null}
          realtyId={item.getProperty().getId()}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          eventOpenCommentForm={eventOpenCommentForm}
        />

        <ClaimFlatButton
          className='hover-visible'
          realtyId={item.getProperty().getId()}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          eventOpenClaimForm={eventOpenClaimForm}
        />


        {
          permission.isAllow(Permission.IS_EDIT) &&
          (

            <a
              href={item.getEditLink()}
              data-tip
              data-for='tip-edit'
              target='_blank'
              className='icon-pencil hover-visible button' />
          )
        }

        {
          permission.isAllow(Permission.IS_GO_PROFILE) &&
          (
            <a
              href={author && author.getManageLink()}
              data-tip
              data-for='tip-profile'
              target='_blank'
              className='icon-edit-user button hover-visible'
            />
          )
        }
      </div>
    );
  }

  /**
   * Жилой комплекс, Коттеджный поселок, Гаражный кооператив, Садоводческое товарищество
   * @returns {Array}
   */
  renderComplex () {
    const item = this.item;
    const complexes = [
      item.getResidentialComplex(),
      item.getCottageComplex(),
      item.getGardenAssociation(),
      item.getGarageComplex()
    ];

    return complexes
      .filter(x => x)
      .map((complex, index) => {
        return complex.getUri() ? (
          <a key={index} className='residential' href={complex.getUri()} target='_blank'>
            {complex.getLabel()}
          </a>
        ) : (
          <span key={index} className='residential'>{complex.getLabel()}</span>
        );
      }
    );
  }

  renderModal () {
    const property = this.item.getProperty();
    const geoLocation = property.getGeoLocation();
    const permission = this.item.getPermissions();

    return (
      <Modal
        isOpen={this.state.showFullInfoModal}
        onRequestClose={this.handlerCloseDescriptionModal}
        portalClassName='description-modal'
        className='description-modal__content'
        overlayClassName='description-modal__overlay'
      >
        <FixedBody />
        <div className='link-object'>
          <a target='_blank' className='location' href={this.item.getLink()}>
            {geoLocation.getShortAddress()}
          </a>

          {
            permission.isAllow(Permission.IS_EDIT) &&
            (
              <a
                href={this.item.getEditLink()}
                target='_blank'
              >редактировать</a>
            )
          }
        </div>
        <div className='description'>
          {this.item.getDescription()}
        </div>
        <div className='photo-gallery-scroll'>
          <div className='photo-gallery'>
            {
              this.item.getPhotos()
                .map((photo, index) => {
                  return (
                    <img key={index} src={getUrlWithSize(photo.get('url'), '320x240')} />
                  );
                })
            }
          </div>
        </div>
      </Modal>
    );
  }

  render () {
    const property = this.item.getProperty();
    const geoLocation = property.getGeoLocation();
    const distance = geoLocation.getDistanceFromCity();

    return (
      <td className='col-description'>
        <a className='slider-container' href={this.item.getLink()} target='_blank'>
          <SingleSlider
            className='property-grid-slider'
            photos={this.item.getPhotos()}
            photoSize='320x240'
            showPhotoCount />
        </a>

        <div className='content-container'>
          <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
            <a target='_blank' className='location' href={this.item.getLink()}>
              {geoLocation.getShortAddress()}
            </a>

            <MapsLinkButton realtyObject={this.item} eventMapModal={this.props.eventMapModal} />
          </div>

          { this.renderLocation() }
          { this.renderComplex() }

          { distance && (<div>{'Удаленность от города: ' + distance + ' км.'}</div>) }

          <div onClick={this.handlerOpenDescriptionModal}>{ truncText(this.item.getDescription(), distance ? 100 : 140) }</div>

          { this.renderControls() }
        </div>

        { this.renderModal() }
      </td>
    );
  }
}

Description.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventOpenCommentForm: PropTypes.func,
  eventOpenClaimForm: PropTypes.func,
  eventMapModal: PropTypes.func
};

Description.defaultProps = {
  eventAddFavorites: id => {},
  eventRemoveFavorites: id => {},
  eventOpenCommentForm: id => {},
  eventOpenClaimForm: id => {},
  eventMapModal: id => {}
};

export default Description;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/Description.jsx